<template>
  <div class="credit-card container-card mB20">
    <masked-input id="cardNumber"
                  v-model="card.number"
                  type="text"
                  class="w100 mB5 mT5"
                  name="cardNumber"
                  required
                  :mask="[/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/]"
                  :guide="false"
                  :placeholder="$t('payment.numeroDeTarjeta')"
                  :class="{'error': !validCard && card.number}"
                  @change="checkNumber()"
                  @keyup="checkNumber()" />
    <b-row>
      <b-col>
        <input id="cardCsc"
               v-model="card.cvc"
               type="text"
               class="tAc w100 mB5 mT5"
               placeholder="CVC"
               name="cardCsc"
               minlength="3"
               maxlength="3"
               required
               :class="{'error': !validCvc && card.cvc}"
               @change="checkCVC()"
               @keyup="checkCVC()" />
      </b-col>
      <b-col>
        <input id="cardExpirationMonth"
               v-model="card.exp_month"
               type="text"
               class="tAc w100 mB5 mT5"
               placeholder="MM"
               name="cardExpirationMonth"
               minlength="2"
               maxlength="2"
               required
               :class="{'error': !validDate && card.exp_month}"
               @change="checkDate()"
               @keyup="checkDate()" />
      </b-col>
      <b-col>
        <input id="cardExpirationYear"
               v-model="card.exp_year"
               type="text"
               class="tAc w100 mB5 mT5"
               placeholder="YY"
               name="cardExpirationYear"
               minlength="2"
               maxlength="2"
               required
               :class="{'error': !validDate && card.exp_year}"
               @change="checkDate()"
               @keyup="checkDate()" />
      </b-col>
    </b-row>
    <input id="cardHolder"
           v-model="card.name"
           :placeholder="$t('payment.nombre')"
           type="text"
           name="cardHolder"
           class="w100 mB5 mT5"
           required
           @change="checkName()"
           @keyup="checkName()" />

  </div>
</template>

<script>
import MaskedInput from 'vue-text-mask'

export default {
  components: {
    MaskedInput
  },
  props: {
    card: {
      type: Object,
      default: () => {}
    },
    validCard: {
      type: Boolean,
      default: false
    },
    validCvc: {
      type: Boolean,
      default: false
    },
    validDate: {
      type: Boolean,
      default: false
    },
    validName: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      acceptedCreditCards: {
        visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
        mastercard: /^5[1-5][0-9]{14}$|^2(?:2(?:2[1-9]|[3-9][0-9])|[3-6][0-9][0-9]|7(?:[01][0-9]|20))[0-9]{12}$/,
        discover: /^65[4-9][0-9]{13}|64[4-9][0-9]{13}|6011[0-9]{12}|(622(?:12[6-9]|1[3-9][0-9]|[2-8][0-9][0-9]|9[01][0-9]|92[0-5])[0-9]{10})$/,
        diners_club: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
        jcb: /^(?:2131|1800|35[0-9]{3})[0-9]{11}$/
      }
    }
  },
  methods: {
    checkNumber() {
      // remove all non digit characters
      var value = this.card.number ? this.card.number.replace(/\D/g, '') : ''
      var sum = 0
      var shouldDouble = false
      // loop through values starting at the rightmost side
      for (var i = value.length - 1; i >= 0; i--) {
        var digit = parseInt(value.charAt(i))

        if (shouldDouble) {
          if ((digit *= 2) > 9) digit -= 9
        }

        sum += digit
        shouldDouble = !shouldDouble
      }

      var valid = sum % 10 === 0
      var accepted = false
      var type = ''

      // loop through the keys (visa, mastercard, amex, etc.)
      Object.keys(this.acceptedCreditCards).forEach(key => {
        var regex = this.acceptedCreditCards[key]
        if (regex.test(value)) {
          accepted = true
          type = key
        }
      })
      this.$emit('update:type', accepted ? type : '')
      this.$emit('update:validCard', true)
      if (!valid || !accepted) this.$emit('update:validCard', false)
    },
    checkCVC() {
      // remove all non digit characters
      this.$emit('update:validCvc', true)
      var cvc = this.card.cvc ? this.card.cvc.replace(/\D/g, '') : undefined
      // american express and cvc is 4 digits
      if (!/^\d{3}$/.test(cvc)) {
        // other card & cvv is 3 digits
        this.$emit('update:validCvc', false)
      }
    },
    checkDate() {
      this.$emit('update:validDate', false)
      let day = this.$moment(`20${this.card.exp_year}-${this.card.exp_month}`)
        .endOf('month')
        .format('DD')
      let date = `${this.card.exp_month}/${day}/${this.card.exp_year}`
      if (
        this.card.exp_month &&
        this.card.exp_year &&
        this.$moment().diff(date, 'days') <= 0
      )
        this.$emit('update:validDate', true)
    },
    checkName() {
      this.$emit('update:validName', false)
      if (this.card.name && this.card.name.length > 0)
        this.$emit('update:validName', true)
    }
  }
}
</script>
<style lang="scss">
@import './credit-card.sass';
</style>
